// Keep in sync with backend/bot_user.py (DEEP_LINK_ID_LEN, channel_/tariff_ payloads).
export const DEEP_LINK_ID_LEN = 8;

export function normalizeBotUsername(botUsername) {
  return String(botUsername || '').replace(/^@/, '').trim();
}

export function resourceShortId(resourceId) {
  return String(resourceId || '').slice(0, DEEP_LINK_ID_LEN);
}

export function telegramStartLink(botUsername, payload) {
  const name = normalizeBotUsername(botUsername);
  if (!name || !payload) return '';
  return `https://t.me/${name}?start=${payload}`;
}

export function channelDeepLink(botUsername, channelId) {
  const short = resourceShortId(channelId);
  if (!short) return '';
  return telegramStartLink(botUsername, `channel_${short}`);
}

export function tariffDeepLink(botUsername, tariffId) {
  const short = resourceShortId(tariffId);
  if (!short) return '';
  return telegramStartLink(botUsername, `tariff_${short}`);
}
